null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js/v0.6.25/javalib/src/main/scala/java/util/concurrent/Throwables.scala